import { render } from "./ModalExcluirPlanoPAP.vue?vue&type=template&id=f6f8055a"
import script from "./ModalExcluirPlanoPAP.vue?vue&type=script&lang=js"
export * from "./ModalExcluirPlanoPAP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__